<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 学生列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_box">
      <!-- 顶部的盒子 -->
      <div class="top_box">
        <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline"
          @click="addAdminstrator">新增学生</el-button>

        <el-input v-model="searchKey" clearable size="mini" placeholder="输入关键词搜索"
          @change="searchKeyChange(tableData,searchKey)">
          <el-button slot="append" icon="el-icon-search" @click="searchKeyChange(tableData,searchKey)"></el-button>
        </el-input>
      </div>

      <!--表格-->
      <div class="table_box">
        <el-table :data="tableData1" @sort-change="onSortChange">
          <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>

          <el-table-column label="姓名" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="name"></el-table-column>

          <el-table-column label="学院" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="college"></el-table-column>

          <el-table-column label="学号" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="num"></el-table-column>

          <el-table-column label="专业" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="major"></el-table-column>

          <el-table-column label="时间" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="time"></el-table-column>
        </el-table>
      </div>
      <!-- 分页栏 -->
      <!-- <div class="pagination_box">      
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"        
        :page-sizes="[4, 8, 12]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"  
          :total="totalItems">         
        </el-pagination> 
      </div> -->
      <div class="pagination_box">      
        <el-pagination   
            @current-change="handleCurrentChange" 
            :current-page="currentPage" 
            :page-sizes="[pageSize]"
            layout="total, sizes, prev, pager, next, jumper"  
            :total="total"> 
        </el-pagination> 
      </div>
    </div>

    <!-- 新增学生对话框 -->
    <div>
      <el-dialog title="新增学生11" :visible.sync="addDialogFormVisible" width="320px" :before-close="((done)=>{closeDialog('addStudent',done)})">

        <el-form :model="addStudent" label-position="right" label-width="55px" ref="addStudent"
          :rules="addStudentRules">

          <el-form-item label="姓名" prop="name">
            <el-input v-model="addStudent.name" autocomplete="off" clearable size="small"
              placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="passWord">
            <el-input v-model="addStudent.passWord" autocomplete="off" clearable size="small" placeholder="请输入密码"
              show-password></el-input>
          </el-form-item>

          <el-form-item label="学院" prop="college">
            <el-select v-model="addStudent.college" value-key="id" placeholder="请选择专业" clearable size="small"
              @change="((e)=>{[addStudent.college,addStudent.college]=[e.id,e.label]})">
              <el-option v-for="item in collegesOptions" :key="item.id" :label="item.label" :value="item"
                :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学号" prop="num">
            <el-input v-model="addStudent.num" autocomplete="off" clearable size="small" placeholder="请输入学号"></el-input>
          </el-form-item>

          <el-form-item label="电话" prop="telephoneNum">
            <el-input v-model="addStudent.telephoneNum" autocomplete="off" clearable size="small"
              placeholder="请输入电话"></el-input>
          </el-form-item>

          <el-form-item label="专业" prop="major">
            <el-select v-model="addStudent.major" value-key="label" placeholder="请选择专业" clearable size="small"
              @change="((e)=>{[addStudent.majorId,addStudent.major]=[e.id,e.label]})">
              <el-option v-for="item in majorsOptions" :key="item.id" :label="item.label" :value="item"
                :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitAddStudent">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 编辑学生对话框 -->
    <div>
      <el-dialog title="编辑学生" :visible.sync="editDialogFormVisible" width="320px">
        <el-form :model="editStudent" label-position="right" label-width="68px" ref="editStudent"
          :rules="editStudentRules">

          <el-form-item label="姓名" prop="name">
            <el-input v-model="editStudent.name" autocomplete="off" clearable size="small"
              placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="修改密码" prop="passWord">
            <el-input v-model="editStudent.passWord" autocomplete="off" clearable size="small" placeholder="请输入密码"
              show-password></el-input>
          </el-form-item>

          <el-form-item label="学院" prop="college">
            <el-select v-model="editStudent.college" value-key="id" placeholder="请选择专业" clearable size="small"
              @change="((e)=>{[editStudent.collegeId,editStudent.college]=[e.id,e.label]})">
              <el-option v-for="item in collegesOptions" :key="item.id" :label="item.label" :value="item"
                :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学号" prop="num">
            <el-input v-model="editStudent.num" autocomplete="off" clearable size="small"
              placeholder="请输入学号"></el-input>
          </el-form-item>

          <el-form-item label="电话" prop="telephoneNum">
            <el-input v-model="editStudent.telephoneNum" autocomplete="off" clearable size="small"
              placeholder="请输入电话"></el-input>
          </el-form-item>

          <el-form-item label="专业" prop="major">

            <el-select v-model="editStudent.major" value-key="id" placeholder="请选择专业" clearable size="small"

              @change="((e)=>{[editStudent.majorId,editStudent.major]=[e.id,e.label]})">

              <el-option v-for="item in majorsOptions" :key="item.id" :label="item.label" :value="item"
                :disabled="item.disabled"></el-option>
            </el-select>
          
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitEditStudent">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { getBrands} from "@/api/brand.js";
  export default {
    name: 'administrators',
    data() {
      // 验证密码1
      var validatePassWord1 = (rulevalue, callback) => {
        if (!value) {
          return callback('请输入密码')
        }
        if (!/^\S*$/.test(value)) {
          callback('密码不能包含空格')
        } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s])+$/.test(value)) {
          callback('字母、数字和标点符号至少包含两种')
        } else if (value.length > 20 || value.length < 6) {
          callback('请输入6-20位密码')
        } else {
          callback()
        }
      }
      // 验证密码2
      var validatePassWord2 = (rule, value, callback) => {
        if (!value) {
          return callback()
        }
        if (!/^\S*$/.test(value)) {
          callback('密码不能包含空格')
        } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s])+$/.test(value)) {
          callback('字母、数字和标点符号至少包含两种')
        } else if (value.length > 20 || value.length < 6) {
          callback('请输入6-20位密码')
        } else {
          callback()
        }
      }
      return {
        // 表格************************************************************************
        // 表格总数据
        tableData: [{
            id: 121,
            name: "软件工程_1",
            collegeId:2,
            college: "学院_1",
            num: "00001",
            majorId: 0,
            major: "软件工程_1",
            telephoneNum: "18912345601"
          },
          {
            id: 2,
            name: "软件工程_2",
            collegeId:2,
            college: "学院_2",
            num: "00002",
            majorId: 0,
            major: "软件工程_2",
            telephoneNum: "18923456702"
          },
          {
            id: 3,
            name: "软件工程_3",
            collegeId:2,
            college: "学院_3",
            num: "00003",
            majorId: 0,
            major: "软件工程_3",
            telephoneNum: "18934567803"
          },
          {
            id: 4,
            name: "软件工程_4",
            collegeId:2,
            college: "学院_4",
            num: "00004",
            majorId: 0,
            major: "软件工程_4",
            telephoneNum: "18945678904"
          },
          {
            id: 5,
            name: "软件工程_5",
            collegeId:2,
            college: "学院_5",
            num: "00005",
            majorId: 0,
            major: "软件工程_5",
            telephoneNum: "18912345605"
          },
          {
            id: 6,
            name: "软件工程_6",
            collegeId:2,
            college: "学院_6",
            num: "00006",
            majorId: 0,
            major: "软件工程_6",
            telephoneNum: "18923456706"
          },
          {
            id: 7,
            name: "软件工程_7",
            collegeId:2,
            college: "学院_7",
            num: "00007",
            majorId: 0,
            major: "软件工程_7",
            telephoneNum: "18934567807"
          },
          {
            id: 8,
            name: "软件工程_8",
            collegeId:2,
            college: "学院_8",
            num: "00008",
            majorId: 0,
            major: "软件工程_8",
            telephoneNum: "18945678908"
          },
          {
            id: 9,
            name: "软件工程_9",
            collegeId:2,
            college: "学院_9",
            num: "00009",
            majorId: 0,
            major: "软件工程_9",
            telephoneNum: "18912345609"
          },
          {
            id: 10,
            name: "软件工程_10",
            collegeId:2,
            college: "学院_10",
            num: "00010",
            majorId: 0,
            major: "软件工程_10",
            telephoneNum: "18923456710"
          },
          {
            id: 11,
            name: "软件工程_11",
            collegeId:2,
            college: "学院_11",
            num: "00011",
            majorId: 0,
            major: "软件工程_11",
            telephoneNum: "18934567811"
          },
          {
            id: 12,
            name: "软件工程_12",
            collegeId:2,
            college: "学院_12",
            num: "00012",
            majorId: 0,
            major: "软件工程_12",
            telephoneNum: "18945678912"
          },
        ],
        // 表格可检索内容 用于检索
        tableDataForm: {
          name: "",
          college: "",
          num: "",
          major: "",
          telephoneNum: "",
        },
        // 新增学生表单************************************************************************
        // 新增学生对话框标识符
        addDialogFormVisible: false,
        // 新增学生表单
        addStudent: {
          name: "",
          passWord: "",
          college: "",
          num: "",
          major: "",
          majorId: "",
          telephoneNum: "",
        },
        // 新增学生验证
        addStudentRules: {
          name: [{
            required: true,
            message: "请输入姓名",
            trigger: ["blur"]
          }],
          num: [{
            required: true,
            message: "请输入学号",
            trigger: ["blur"]
          }],
          college: [{
            required: true,
            message: "请输入学院",
            trigger: ["blur"]
          }],
          major: [{
            required: true,
            message: "请选择专业",
            trigger: ["blur"]
          }],
          telephoneNum: [{
            required: true,
            message: "请输入电话",
            trigger: ["blur"]
          }],
          passWord: [{
            required: true,
            validator: validatePassWord1,
            trigger: ["blur"]
          }],
        },
        // 编辑学生表单************************************************************************
        // 编辑学生对话框标识符
        editDialogFormVisible: false,
        // 编辑学生表单
        editStudent: {
          id: "",
          name: "",
          passWord: "",
          college: "",
          num: "",
          majorId: "",
          major: "",
          telephoneNum: "",
        },
        // 编辑学生验证
        editStudentRules: {
          name: [{
            required: true,
            message: "请输入姓名",
            trigger: ["blur"]
          }],
          num: [{
            required: true,
            message: "请输入学号",
            trigger: ["blur"]
          }],
          college: [{
            required: true,
            message: "请输入学院",
            trigger: ["blur"]
          }],
          major: [{
            required: true,
            message: "请选择专业",
            trigger: ["blur"]
          }],
          telephoneNum: [{
            required: true,
            message: "请输入电话",
            trigger: ["blur"]
          }],
          passWord: [{
            required: false,
            validator: validatePassWord2,
            trigger: ["blur"]
          }],
        },
        // 搜索************************************************************************
        // 搜索关键字
        searchKey: "",
        // 搜索结果
        searchResult: [],
        // 分页***********************************************************************
        // 采集设备表格前页数据
        tableDataEnd: [],
        //
        //
        tableData1:[],
        total: 1, 
        isShow: false,
        pageSize:[1],
        currentPage: 1,
        //
        //
        // 当前页数
        currentPage: 1,
        // 表格展示的行数
        pageSize: 8,
        // 总行数
        totalItems: 0,
        // 当前行
        currentRow: 0,
        // 当前表格排序
        currentSort: null,
        // 其他***********************************************************************
        // 专业清单
        majorsOptions: [{
            id: 0,
            label: "软件工程"
          },
          {
            id: 1,
            label: "环境工程"
          },
          {
            id: 2,
            label: "土木工程"
          },
          {
            id: 3,
            label: "材料工程"
          },
          {
            id: 4,
            label: "电气及自动化"
          }
        ],
        collegesOptions: [{
            id: 0,
            label: "计算机学院"
          },
          {
            id: 1,
            label: "环境学院"
          },
          {
            id: 2,
            label: "土木学院"
          },
          {
            id: 3,
            label: "机械学院"
          },
          {
            id: 4,
            label: "自动化学院"
          }
        ],
      };
    },
    created() {
      // 请求表格数据
      // this.getTableData(false) 
        getBrands().then((response) => {
        //
        this.tableData1 = response.data.items.records   
        // 总记录数
        this.total = response.data.items.total
        // 每页显示的条数
        this.pageSize = response.data.items.size
        // 网络请求成功后，显示分页
        this.currentPage= response.data.items.current
        //
        this.isShow = true;
      })
    },
    mounted() {
    },

    methods: {
      // *********************************************************************************************************
      // 表格数据获取
      // *********************************************************************************************************
      // 请求表格数据 falg为是否还原表格状态
      getTableData(flag) {
        // TODO 获取表格数据
        this.totalItems = this.tableData.length
        this.handleCurrentChange(1)  //传去的参数为一
      },
      // *********************************************************************************************************
      // 新增学生
      // *********************************************************************************************************
      // 添加学生
      addAdminstrator() {
        // TODO 获取专业清单
        this.addDialogFormVisible = !this.addDialogFormVisible
      },

      // 提交添加学生表单
      submitAddStudent() {
        // TODO 验证 上传表单数据
        // 成功重新获取表格信息 跳转最后一页
        // 失败弹框报错
        // 成功 重置表单信息 关闭对话框
        // 不成功 不重置表单信息 不关闭对话框
        this.$refs['addStudent'].validate((v) => {
          if (v) 
          {
            this.tableData.push(JSON.parse(JSON.stringify(this.addStudent)))
            this.totalItems = this.tableData.length
            this.handleCurrentChange(1)
            this.addDialogFormVisible = false
            this.$refs['addStudent'].resetFields();
          } 
          else 
          {
            return false;
          }
        });
      },
      // *********************************************************************************************************
      // 编辑学生
      // *********************************************************************************************************
      // 编辑学生
      editAdminstrator(row) {
        this.editDialogFormVisible = !this.editDialogFormVisible
        this.currentRow = row.$index
        this.editStudent = JSON.parse(JSON.stringify(row.row))//这条指令将一行所有的数据全部转变为JSON数据
      },

      // 提交编辑学生表单
      submitEditStudent() {
        try {
          // 执行更新学生数据的操作
          // 更新成功，可以进行一些操作，如关闭编辑对话框等
          this.editDialogFormVisible = !this.editDialogFormVisible;
          console.log('编辑后的学生表单数据:', this.editStudent);
          console.log('更新后的表格数据:', this.tableData);

          // 更新表格数据
          const index = this.currentRow;
          if (index !== -1) {
            // this.tableData.splice(index, 1, this.editStudent);
            this.$set(this.tableData, index, this.editStudent);
          }
          // 自动刷新表格数据
          this.getTableData(false);
        } catch (error) {
          // 处理更新失败的情况，可以进行一些错误处理操作
          console.error('更新学生数据失败:', error);
        }
      },
      // *********************************************************************************************************
      // 删除学生
      // *********************************************************************************************************
      // 删除学生
      deleteAdminstrator(row) 
      {
        const index = this.tableData.indexOf(row.row);
        
        if (index !== -1) {
          this.tableData.splice(index, 1);
          this.totalItems = this.tableData.length;
          this.handleCurrentChange(this.currentPage);
        }
      },

      // *********************************************************************************************************
      // 表格排序功能
      // *********************************************************************************************************
      // 表头某列点击排序
      onSortChange({ prop, order }) 
      {
        this.currentSort = {
          prop,
          order
        }
        if (this.searchKey === "") 
        {
          this.tableData1.sort(this.compare(prop, order));
        }
         else 
        {
          this.searchResult.sort(this.compare(prop, order));
        }
        this.handleCurrentChange(this.currentPage)
      },
      // 排序比较
      compare(propertyName, sort) 
      {
        return function(obj1, obj2) 
        {
          var value1 = obj1[propertyName]
          var value2 = obj2[propertyName]
          //
          if (typeof value1 === 'string' && typeof value2 === 'string') //判断连个值是否都是字符串
          {
            const res = value1.localeCompare(value2, 'zh')
            return sort === 'ascending' ? res : -res
          } 
          else 
          {
            if (value1 <= value2) 
            {
              return sort === 'ascending' ? -1 : 1
            } 
            else if (value1 > value2) 
            {
              return sort === 'ascending' ? 1 : -1
            }
          }
        }
      },
      // *********************************************************************************************************
      // 表格搜索功能
      // *********************************************************************************************************
      // 关键字变化或输入框失焦后的操作
      searchKeyChange(tableData, key) {
        if (key !== "") {
          this.searchResult = tableData1.filter((obj) => this.searchCheck(obj, this.tableDataForm))
          this.totalItems = this.searchResult.length
        } else {
          this.totalItems = this.tableData.length
        }
        this.handleCurrentChange(1)
      },
      // 判断对象中是否包含搜索关键字 返回布尔值
      searchCheck(obj, form) {
        var flag = false
        for (let i = 0; i < Object.getOwnPropertyNames(obj).length - 1; i++) {
          // 获取对象的第i个key值
          var originalKey = Object.getOwnPropertyNames(obj)[i]
          //
          for (let j = 0; j < Object.getOwnPropertyNames(form).length - 1; j++) {
            // 获取表格样式的第j个key值
            var targetKey = Object.getOwnPropertyNames(form)[j]
            // 如果key值匹配 则进行搜索
            if (originalKey === targetKey) {
              var value = Object.values(obj)[i]
              // 判断是否是数组
              if (Array.isArray(value)) {
                // 如果是数组 则遍历数组中的元素 调用searchCheck返回布尔值
                for (let k = 0; k < value.length; k++) {
                  flag = flag || this.searchCheck(value[k], Object.values(form)[j][0])
                }
                break
              }
              // 判断是否是对象
              else if (Object.prototype.toString.call(value) === '[object Object]') {
                // 如果是对象 则遍历对象元素 调用searchCheck返回布尔值
                flag = flag || this.searchCheck(value[k], Object.values(form)[j])
                break
              }
              // 判断是否是数字
              else if (typeof(Object.values(obj)[i]) === "number") {
                value = Object.values(obj)[i].toString()
              }
              // 判断是否是字符串
              else if (typeof(Object.values(obj)[i]) === "string") {
                value = Object.values(obj)[i]
              } else {
                break;
              }
              console.log(value);
              // 判断是否和关键词匹配
              flag = flag || value.toLowerCase().includes(this.searchKey.toLowerCase())
            }
          }
        }
        return flag
      },
      // *********************************************************************************************************
      // 分页功能
      // *********************************************************************************************************
      //监控当前页码 页码变化后 重新选取当前页的数据
      currentChangePage(list) {
        // from：当前页的第一行数据在list中的序号  to：下一页的第一行数据在list中的序号
        let from = (this.currentPage - 1) * this.pageSize;
        let to = this.currentPage * this.pageSize;
        this.tableDataEnd = [];
        for (; from < to; from++) {
          if (list[from]) {
            this.tableDataEnd.push(list[from]);
          }
        }
      },
      //每页展示的行数变化后的操作
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      
      //页码变化后的操作
      handleCurrentChange(val) {
        this.currentPage = val;//传过来的数据为1，代表取的是第一页的数据

        getBrands(val).then((response) => {
        //
        this.tableData1 = response.data.items.records;     
        // 总记录数
        this.total = response.data.items.total;
        // 每页显示的条数
        this.pageSize = response.data.items.size;
        // 网络请求成功后，显示分页
        this.currentPage= response.data.items.current;
        this.isShow = true;
      })

        // // 判断是否在搜索
        // if (this.searchKey === "") {
        //   this.currentChangePage(this.tableData);
        // } else {
        //   this.currentChangePage(this.searchResult);
        // }
      },
     
      // *********************************************************************************************************
      // 其他
      // *********************************************************************************************************
      // 关闭对话框
      closeDialog(ref, done) {
        this.$refs[ref].resetFields();
        done();
      },
    }
  };
</script>

<style lang="less" scoped>
  .main_box {
    border-radius: 8px 8px 8px 8px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  }

  .top_box {
    text-align: right;
    background-color: #fff;
    padding: 10px 20px;
    border-bottom: 1px solid #E9EEF7;
    border-radius: 8px 8px 0px 0px;

    .el-input {
      width: 240px;
      margin-left: 10px;
    }

    .el-input .el-button {
      width: 40px;
      padding: 0;
    }
  }

  .table_box {
    background-color: #fff;
    padding: 10px 20px;

    /deep/ .el-table__header tr th.el-table__cell {
      color: #515a6e;
      background-color: #f8f8f9;
      padding: 8px 0;

      .cell {
        height: 34px;
        line-height: 34px;
      }
    }
  }

  .pagination_box {
    padding: 0px 20px 10px 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  /deep/ .el-dialog {
    border-radius: 8px 8px 8px 8px;
  }

  /deep/ .el-dialog__header {
    height: 50px;
    line-height: 50px;
    padding: 0 30px 0 30px;
    border-bottom: 1px solid #e0e0e0;

    .el-dialog__title {
      color: #666;
      font-size: 18px;
      font-weight: 700;
    }
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px 0 20px;
  }

  /deep/ .el-dialog__footer {
    padding-top: 10px;
  }

  .el-dialog .el-button {
    width: 100%;
  }

  .el-form {
    width: 100%;
    margin: 0 auto;

    .el-form-item {
      margin-bottom: 10px;
    }

    /deep/ .el-form-item__error {
      padding-top: 0;
    }
  }

  /deep/ .el-form-item__label {
    color: #666;
  }

  .el-select {
    width: 100%;
  }
</style>
